import axiosInstanceAI from "@/api/axiosInstanceAI";

export const ARTIFACT_URL_PREFIX = "/conversation-chat/artifacts/";

function artifactPath(url) {
  const value = String(url || "");
  const index = value.indexOf(ARTIFACT_URL_PREFIX);
  return index === -1 ? value : value.slice(index);
}

export async function downloadArtifact(url, fallbackName) {
  const baseURL =
    axiosInstanceAI.defaults.baseURL || process.env.REACT_APP_AI_BASE_URL || "";
  const path = artifactPath(url);
  const token = localStorage.getItem("token");
  const response = await fetch(`${baseURL}${path}`, {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });

  if (!response.ok) throw new Error(`Download failed: ${response.status}`);

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fallbackName || path.split("/").pop() || "proposal";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}

export function handleArtifactLinkClick(event) {
  const anchor = event.target.closest?.("a");
  if (!anchor) return false;

  const href = anchor.getAttribute("href") || "";
  if (!href.includes(ARTIFACT_URL_PREFIX)) return false;

  event.preventDefault();
  downloadArtifact(href).catch((error) =>
    console.error("Artifact download failed:", error),
  );
  return true;
}
